import React from 'react';
import { useDropzone } from 'react-dropzone';
import { motion } from 'framer-motion';
import { Upload, Shield } from 'lucide-react';
import { FADE_UP } from '../../lib/anim';

export const UploadStep = ({ onDrop }) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { 'application/pdf': ['.pdf'], 'text/plain': ['.txt'] },
    maxFiles: 1
  });

  return (
    <motion.div {...FADE_UP}>
      <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
        <h1 style={{ fontSize: 'clamp(1.75rem, 4vw, 2.5rem)', marginBottom: '0.75rem' }}>Drop your CV</h1>
        <p style={{ color: 'var(--text-secondary)', fontSize: '1rem', maxWidth: '480px', margin: '0 auto' }}>
          Our AI will analyze your profile and match you with immigration pathways across 20+ countries.
        </p>
      </div>

      <div
        {...getRootProps()}
        data-testid="upload-dropzone"
        style={{
          minHeight: '320px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          border: `2px dashed ${isDragActive ? 'var(--brand-purple)' : 'var(--border-default)'}`,
          borderRadius: 'var(--radius-lg)', background: isDragActive ? 'var(--surface-active)' : 'var(--bg-paper)',
          cursor: 'pointer', transition: 'all 0.3s',
          boxShadow: isDragActive ? '0 0 40px rgba(246,116,37,0.15)' : 'none'
        }}
      >
        <input {...getInputProps()} data-testid="upload-input" />
        <div style={{ width: '72px', height: '72px', borderRadius: '50%', background: 'var(--bg-elevated)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1.5rem', border: '1px solid var(--border-default)' }}>
          <Upload size={32} color="var(--brand-purple)" />
        </div>
        <p style={{ fontSize: '1.125rem', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '0.5rem' }}>
          {isDragActive ? 'Drop it here' : 'Drag & drop your CV here'}
        </p>
        <p style={{ color: 'var(--text-muted)', fontSize: '0.875rem' }}>or click to browse — PDF or TXT</p>
        <div style={{ display: 'flex', gap: '20px', marginTop: '2rem' }}>
          {['256-bit encrypted', 'AI-powered analysis', 'Instant results'].map(t => (
            <span key={t} style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '0.75rem', color: 'var(--text-muted)' }}>
              <Shield size={12} color="var(--brand-purple)" />{t}
            </span>
          ))}
        </div>
      </div>
    </motion.div>
  );
};
